import axios from 'axios'

// Get all invitations
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/invitation`)
  return data
}

// Get shows with sections
const getShows = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/invitation/show`)
  return data
}

// Create invitation
const create = async (
  show,
  type,
  discount,
  expiration,
  sections,
  emails
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/invitation`, {
    show,
    type,
    discount,
    expiration,
    sections,
    emails
  })
  return data
}

// Resend invitation mail
const resend = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/invitation/${id}/resend`)
  return data
}

export {
  getAll,
  getShows,
  create,
  resend
}
